import z from 'zod';

import { AccessorySortOrderSchema } from './AccessorySortOrder';
import { AccessorySortOrder } from './AccessorySortOrder';
import { CharacteristicSchema } from './Characteristic';
import { Characteristic } from './Characteristic';
import { DecimalRangeSchema } from './DecimalRange';
import { DecimalRange } from './DecimalRange';
import { DoubleRangeSchema } from './DoubleRange';
import { DoubleRange } from './DoubleRange';

export type GetAccessoryBySearchParamsRequestModel = {
	pageIndex: number | null;
	pageSize: number | null;
	searchTerm: string | null;
	showOnlyDeleted: boolean;
	sortOrder: AccessorySortOrder | null;
	priceRange: DecimalRange | null;
	characteristics: Characteristic[];
	carbonDioxideRange: DoubleRange | null;
	carbonDioxideLabelIds: string[];
	categoryIds: string[];
	tagIds: string[];
	currencyCode: string | null;
};

export const GetAccessoryBySearchParamsRequestModelSchema: z.ZodType<GetAccessoryBySearchParamsRequestModel> =
	z.object({
		pageIndex: z.number().nullable(),
		pageSize: z.number().nullable(),
		searchTerm: z.string().nullable(),
		showOnlyDeleted: z.boolean(),
		sortOrder: z.lazy(() => AccessorySortOrderSchema).nullable(),
		priceRange: z.lazy(() => DecimalRangeSchema).nullable(),
		characteristics: z.lazy(() => CharacteristicSchema).array(),
		carbonDioxideRange: z.lazy(() => DoubleRangeSchema).nullable(),
		carbonDioxideLabelIds: z.string().array(),
		categoryIds: z.string().array(),
		tagIds: z.string().array(),
		currencyCode: z.string().nullable(),
	});
